import type { ReactNode } from 'react';
import highlightMatches from './highlightMatches';
import { useSearchHighlight } from './SearchHighlightContext';

interface HighlightedTextProps {
  children?: ReactNode;
}

const HighlightedText = ({ children }: HighlightedTextProps) => {
  const query = useSearchHighlight();
  const isText = typeof children === 'string' || typeof children === 'number';

  return <>{isText ? highlightMatches(children, query) : children}</>;
};

export default HighlightedText;
